import { useState, useEffect } from 'react';

import { POLARIZING_TAGS } from '../constants/constants';
import CollapsibleForm from '../generic/CollapsibleForm';
import TagSelector from '../generic/TagSelector';

const PolarizingPreferences = ({ dietaryPreferences, tags, customerTags }) => {
  const [formVisible, setFormVisibility] = useState(false);
  const [polarizingTagsText, setPolarizingTagsText] = useState('');
  const [filteredTags, setFilteredTags] = useState([]);
  const [initialPrefs, setInitialPrefs] = useState(null);
  const [currentPrefs, setCurrentPrefs] = useState([]);

  const currentPrefsMatchInitial =
    currentPrefs.length === initialPrefs?.length &&
    currentPrefs.every((pref) => initialPrefs.includes(pref));
  const tagsSet = new Set(tags.map((t) => t.id));
  const tagsUsedInSection = customerTags.filter((tag) => tagsSet.has(tag.id));
  let noTagsPreviously = false;

  const createTagsText = (tags) => {
    let noTags = tags.length === 0;
    let currentCustomerTagNumber = tagsUsedInSection.length;

    if (noTags) {
      if (currentCustomerTagNumber === 0 && !noTagsPreviously) {
        return;
      }
      if (currentCustomerTagNumber > 0 || noTagsPreviously) {
        setPolarizingTagsText('No thanks');
      }
    } else {
      setPolarizingTagsText(tags.map((t) => t.name).join(', '));
    }
  };

  useEffect(() => {
    const tagsIdMap = tags.reduce((acc, tag) => {
      acc[tag.id] = tag;
      return acc;
    }, {});

    setFilteredTags(
      POLARIZING_TAGS.reduce((acc, tId) => {
        if (tagsIdMap[tId]) {
          acc.push(tagsIdMap[tId]);
        }
        return acc;
      }, [])
    );
  }, [tags]);

  const handleOnSelect = (tags, initialTags, currentTags) => {
    if (tags.length === 0 && !noTagsPreviously) noTagsPreviously = true;
    createTagsText(tags);

    if (initialPrefs === null) setInitialPrefs(initialTags);
    setCurrentPrefs(currentTags);
  };

  return (
    <CollapsibleForm
      title="Taste for Adventure"
      text={polarizingTagsText ? polarizingTagsText : 'Set your preferences.'}
      iconDesktop={`/public/img/preferences/polarizing_icon.svg`}
      contentVisible={formVisible}
      toggleForm={() => setFormVisibility(!formVisible)}
      dataCy={'polarizing-preferences'}
    >
      <div className="protein-preferences" data-testid="polarizing-preferences">
        <div className="hr-mb-32_fixed hr-center-txt">
          <div className="hr-paragraph">
            Would you be interested in trying these types of foods?
          </div>
        </div>
        <TagSelector
          tags={filteredTags}
          customerTags={customerTags}
          onSelect={handleOnSelect}
          dietaryPreferences={dietaryPreferences}
        />
        <button
          data-testid="polarizing-preferences-update-button"
          className={'hr-btn-blue hr-max'}
          disabled={currentPrefsMatchInitial}
          onClick={() => {
            setFormVisibility(false);
            setInitialPrefs(currentPrefs);
          }}
        >
          Update
        </button>
      </div>
    </CollapsibleForm>
  );
};

export default PolarizingPreferences;
